import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarClock, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { FOLLOWUPS } from "@/constants/testIds";

/** Tarjeta del Dashboard con la metrica de recurrencia (motor de Seguimiento).
 * Admin ve el monto de ingreso potencial; Profesional ve solo el conteo de
 * SUS pacientes (sin monto, scoping ya resuelto por el backend); Recepcion
 * ve el conteo global sin monto. Clickeable -> /seguimiento. */
export default function FollowUpKpiCard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const isAdmin = user?.role === "admin";
  const isProfessional = user?.role === "professional";

  useEffect(() => {
    api.get("/followups/summary").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  return (
    <button
      type="button"
      onClick={() => navigate("/seguimiento")}
      className="w-full bg-white border border-border rounded-xl p-5 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 text-left flex items-center gap-4 flex-wrap"
      data-testid={FOLLOWUPS.dashboardCard}
    >
      <div className="w-11 h-11 rounded-lg bg-brand-light flex items-center justify-center shrink-0">
        <CalendarClock className="w-5 h-5 text-brand" />
      </div>
      <div className="flex-1 min-w-[180px]">
        <p className="text-sm font-medium text-foreground">
          {isAdmin ? "Ingreso potencial en seguimiento" : isProfessional ? "Tus pacientes en seguimiento" : "Pacientes en seguimiento"}
        </p>
        {data?.criterion_label && (
          <p className="text-xs text-muted-foreground mt-0.5" data-testid={FOLLOWUPS.dashboardCardCriterion}>{data.criterion_label}</p>
        )}
      </div>
      <div className="text-right">
        {isAdmin ? (
          <p className="font-serif text-2xl sm:text-3xl text-foreground" data-testid={FOLLOWUPS.dashboardCardAmount}>
            ${(data?.potential_revenue ?? 0).toFixed(2)}
          </p>
        ) : (
          <p className="font-serif text-2xl sm:text-3xl text-foreground" data-testid={FOLLOWUPS.dashboardCardCount}>
            {data?.patient_count ?? "-"}
          </p>
        )}
        {isAdmin && (
          <p className="text-xs text-muted-foreground" data-testid={FOLLOWUPS.dashboardCardCount}>{data?.patient_count ?? "-"} pacientes</p>
        )}
      </div>
      <ArrowRight className="w-4 h-4 text-muted-foreground shrink-0" />
    </button>
  );
}
